var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSgd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 100 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_1274",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 75
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H94C97.3137 0 100 2.68629 100 6V69C100 72.3137 97.3137 75 94 75H6C2.68629 75 0 72.3137 0 69V6Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_1274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 0H0V37H100V0Z",
    fill: "#E10E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 37H0V75H100V37Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3018 27.6628C17.9823 25.2778 16.439 22.0792 16.439 18.1884C16.439 14.5221 17.898 11.6321 19.9837 9.27518C21.3866 7.67585 22.9673 6.33843 25.1933 5.56215C17.4959 4.13117 9.19055 10.0515 9.19055 18.4222C9.19055 26.793 18.0103 32.5917 24.9688 30.9737C23.2385 30.2254 21.686 29.0376 20.3111 27.6534L20.3018 27.6628Z",
    fill: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 14H27V19H22V14Z",
    fill: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 8H35V13H30V8Z",
    fill: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 14H43V19H38V14Z",
    fill: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 22H40V27H35V22Z",
    fill: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 22H30V27H25V22Z",
    fill: "#F1F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94 0C97.3137 0 100 2.68629 100 6V69C100 72.3137 97.3137 75 94 75H6C2.68629 75 0 72.3137 0 69V6C0 2.68629 2.68629 0 6 0H94ZM6 6V69H94V6H6Z",
    fill: "black",
    fillOpacity: 0.08
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSgd);
export default __webpack_public_path__ + "static/media/SGD.fc8adeee380a52373cc4de94828d8657.svg";
export { ForwardRef as ReactComponent };